import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CreditsBar, useCredits } from "./TavilyCredits";
import { Plus, Radar } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CompetitorForm } from "./CompetitorForm";
import { CompetitorReport } from "./CompetitorReport";
import { AdminOnlyBanner, fmtDate } from "./shared";

export const ClientCompetitor = ({ client }) => {
  const [config, setConfig] = useState(null);
  const [list, setList] = useState(null);
  const [sel, setSel] = useState(null);
  const [form, setForm] = useState(null);
  const [sp] = useSearchParams();
  const [credits] = useCredits([list?.length]);
  useEffect(() => {
    api.get(`/admin-ai/clients/${client.id}/competitor/config`).then((r) => setConfig(r.data)).catch(() => {});
    api.get(`/admin-ai/clients/${client.id}/competitor`).then((r) => { setList(r.data); const want = sp.get("analisi"); if (r.data.length) setSel(r.data.some((x) => x.id === want) ? want : r.data[0].id); else setForm({}); }).catch(() => setList([]));
  }, [client.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const done = (a) => { setList((l) => [a, ...(l || [])]); setSel(a.id); setForm(null); };
  const current = (list || []).find((x) => x.id === sel);
  return (
    <div data-testid="client-competitor">
      <AdminOnlyBanner>Competitor & trend: ricerca web + AI, visibile solo a te.</AdminOnlyBanner>
      <div className="mb-4"><CreditsBar c={credits} /></div>
      <div className="grid gap-5 lg:grid-cols-[280px_1fr]">
        <aside className="space-y-2" data-testid="competitor-history">
          <Button onClick={() => { setForm({}); setSel(null); }} className="w-full rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="competitor-new"><Plus className="h-4 w-4 mr-1" />Nuova analisi</Button>
          {list && !list.length && <div className="text-sm text-slate-600 px-1">Nessuna analisi salvata.</div>}
          {(list || []).map((a) => (
            <button key={a.id} onClick={() => { setSel(a.id); setForm(null); }} data-testid={`competitor-history-${a.id}`}
              className={`w-full text-left rounded-xl border px-3 py-2.5 transition-colors ${sel === a.id ? "border-[#0A1128] bg-white" : "border-[#5FB3EA] bg-white/60 hover:bg-white"}`}>
              <div className="flex items-center gap-2 text-sm font-bold text-[#0A1128]"><Radar className="h-4 w-4" />{fmtDate(a.created_at)}</div>
              <div className="text-[11px] text-slate-500">{a.modalita === "web" ? `${a.fonti?.length || 0} fonti web` : a.automatica ? "Automatica · stima AI" : "Solo stima AI"} · {a.competitor?.length || 0} competitor · {a.crediti_ricerca || 0} crediti</div>
            </button>
          ))}
        </aside>
        <section className="min-w-0">
          {form && <CompetitorForm clientId={client.id} config={config} credits={credits} initial={form.input} onDone={done} />}
          {!form && current && <CompetitorReport key={current.id} a={current} history={list} onRerun={(input) => setForm({ input })} onDeleted={(id) => { setList((l) => l.filter((x) => x.id !== id)); setSel(null); setForm({}); }} />}
        </section>
      </div>
    </div>
  );
};
